/**
 * Shared body renderer for the provider/payer columns in ruleset tables.
 * Renders a styled label for default rules (which have no provider or payer),
 * and the regular name otherwise.
 *
 * Most ruleset types use "Default" rules purely as a template that gets copied
 * onto payer/provider combinations — they are never applied directly. Professional
 * Modifier rules behave differently: the default row is used as a live fallback
 * when no payer/provider-specific rule exists, so it is labeled "Global" instead.
 */
export function defaultScopeCell(
  row: { isDefault?: boolean },
  value?: string,
  defaultLabel = "Default"
) {
  if (row.isDefault) {
    return (
      <span
        style={{
          color: "#6b7280",
          fontStyle: "italic",
          fontWeight: 600,
        }}
      >
        {defaultLabel}
      </span>
    );
  }
  return value ?? "";
}
